import React from 'react';
import { Bar, Line, Doughnut, Pie } from 'react-chartjs-2';
import { Chart as ChartJS, registerables } from 'chart.js';

import defaultColors from '../app/defaultChartColors';

ChartJS.register(...registerables);

const EMPTY_CHART_MIN_HEIGHT = 200;

export function hasChartData(datasets) {
    if (!datasets?.length) {
        return false;
    }

    const valueColumn = datasets[0]?.columns?.[1]?.field;
    if (!valueColumn) {
        return false;
    }

    return datasets.some(({ rows }) => {
        if (!rows?.length) {
            return false;
        }

        return rows.some((row) => {
            const value = row[valueColumn];
            const num = Number(value);
            return value != null && value !== '' && Number.isFinite(num) && num !== 0;
        });
    });
}

const Chart = ({ type, data: datasets }) => {
    if (!hasChartData(datasets)) {
        return (
            <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: EMPTY_CHART_MIN_HEIGHT }}
            >
                <span className="text-muted">Sin datos para el período seleccionado</span>
            </div>
        );
    }

    const labelColumn = datasets[0]?.columns[0].field;
    const valueColumn = datasets[0]?.columns[1].field;
    const colorColumn = datasets[0]?.columns[2]?.field;

    const formattedData = {
        labels: datasets[0]?.rows.map((row) => row[labelColumn]),
        datasets: datasets.map(({ label, rows, color }, index) => ({
            label,
            data: rows.map((row) => row[valueColumn]),
            backgroundColor: rows.map((row) => row[colorColumn] || color || defaultColors[index]),
            borderColor: color || defaultColors[index],
        })),
    };

    switch (type) {
        case 'line':
            return <Line data={formattedData} />;
        case 'bar':
            return <Bar data={formattedData} />;
        case 'doughnut':
            return <Doughnut data={formattedData} />;
        case 'pie':
            return <Pie data={formattedData} />;
        default:
            return null;
    }
};

export default Chart;
